import React from 'react';
import { motion } from 'framer-motion';
import logo from '../assets/logo.png';

const Logo = () => {
  return (
    <motion.div
      className="logo-wrapper"
      whileHover={{ scale: 1.05 }}
      transition={{ duration: 0.3 }}
    >
      <img src={logo} alt="Mittral Life Science Logo" className="logo" />
      <style jsx>{`
        .logo-wrapper {
          display: block;
          line-height: 0;
        }
        .logo {
          height: 36px;
          width: auto;
          display: block;
        }
        @media (min-width: 768px) {
          .logo {
            height: 44px;
          }
        }
        @media (min-width: 1024px) {
          .logo {
            height: 52px;
          }
        }
      `}</style>
    </motion.div>
  );
};

export default Logo; 